<script setup lang="ts">
import { ref } from "vue";
import BacksideTemplateA6 from "@/components/backsideTemplate/BacksideTemplateA6.vue";
import BacksideTemplateA5 from "@/components/backsideTemplate/BacksideTemplateA5.vue";
import BacksideTemplateA51 from "@/components/backsideTemplate/BacksideTemplateA51.vue";
import BacksideTemplateA4 from "@/components/backsideTemplate/BacksideTemplateA4.vue";
import { BACKSIDE_FORMAT } from "@/constant";
import type { BacksideFormat } from "@/types/backsideTemplate";

const activeFormat = ref<BacksideFormat>(BACKSIDE_FORMAT.A6);
</script>

<template>
  <main style="padding: 24px">
    <pn-tablist
      :value="activeFormat"
      @tabchange="activeFormat = ($event as CustomEvent).detail"
    >
      <pn-tab :value="BACKSIDE_FORMAT.A6" label="A6" />
      <pn-tab :value="BACKSIDE_FORMAT.A5" label="A5" />
      <pn-tab :value="BACKSIDE_FORMAT.A51" label="A51" />
      <pn-tab :value="BACKSIDE_FORMAT.A4" label="A4" />
    </pn-tablist>
    <BacksideTemplateA6 v-if="activeFormat === BACKSIDE_FORMAT.A6" />
    <BacksideTemplateA5 v-else-if="activeFormat === BACKSIDE_FORMAT.A5" />
    <BacksideTemplateA51 v-else-if="activeFormat === BACKSIDE_FORMAT.A51" />
    <BacksideTemplateA4 v-else-if="activeFormat === BACKSIDE_FORMAT.A4" />
  </main>
</template>
